import Api from './Api';

export default {
  getSettings: () => Api.get('/v1/user/lkSettings'),
};
